import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["image", "preload", "unoptimized", "responsive", "loaderOptions", "quality"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import NextImage from 'next/legacy/image';
import React, { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CONTENTFUL_CDN_HOST = 'images.ctfassets.net';

var Image = function Image(_ref) {
  var image = _ref.image,
      _ref$preload = _ref.preload,
      preload = _ref$preload === void 0 ? false : _ref$preload,
      _ref$unoptimized = _ref.unoptimized,
      unoptimized = _ref$unoptimized === void 0 ? false : _ref$unoptimized,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? false : _ref$responsive,
      _ref$loaderOptions = _ref.loaderOptions,
      loaderOptions = _ref$loaderOptions === void 0 ? {
    resize: false
  } : _ref$loaderOptions,
      _ref$quality = _ref.quality,
      quality = _ref$quality === void 0 ? 75 : _ref$quality,
      props = _objectWithoutProperties(_ref, _excluded);

  var shouldOptimize = !unoptimized && image.src.includes(CONTENTFUL_CDN_HOST) && image.src.indexOf('.svg') === -1;
  var imageLoader = useCallback(function (_ref2) {
    var src = _ref2.src,
        width = _ref2.width,
        quality = _ref2.quality;

    if (!shouldOptimize) {
      return src;
    }

    var urlObject = new URL(src);
    urlObject.searchParams.set('fm', 'webp');

    if (quality) {
      urlObject.searchParams.set('q', String(quality));
    }

    if (loaderOptions.resize) {
      urlObject.searchParams.set('w', String(width));
    }

    return urlObject.toString();
  }, []);
  var getImageSource = useCallback(function () {
    var src = image.src;

    if (src.startsWith('data')) {
      return src;
    }

    if (src.startsWith('//')) {
      return "https:".concat(src);
    }

    if (src.startsWith('http') || src.startsWith('/')) {
      return src;
    }

    return "https:".concat(src);
  }, [image]);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx(NextImage, {
      alt: image.alt,
      src: getImageSource(),
      loader: imageLoader,
      unoptimized: unoptimized || !shouldOptimize,
      placeholder: image.placeholder ? 'blur' : 'empty',
      blurDataURL: image.placeholder,
      width: image.width,
      height: image.height,
      priority: preload,
      layout: responsive ? 'responsive' : undefined,
      quality: quality
    })
  }));
};

export default Image;